import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  backButton: {
    backgroundColor: theme.palette.white,
  },
}))

export default styles
